import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { useParams } from 'react-router-dom';
import { investmentData } from '@/data/investments';
import NotFound from './NotFound';
import InvestmentDetailHero from '@/components/InvestmentDetailHero';
import FinancialsTable from '@/components/FinancialsTable';
import Overview from '@/components/TabContent/Overview';
import NewDetails from '@/components/TabContent/NewDetails';
import Documents from '@/components/TabContent/Documents';
import Premise from '@/components/TabContent/Premise';
import Essentials from '@/components/TabContent/Essentials';
import Content from '@/components/TabContent/Content';
import { Button } from '@/components/Button';

const InvestmentDetail = () => {
  const { id } = useParams<{ id: string }>();
  const investment = investmentData.find(inv => inv.id === id);

  if (!investment) {
    return <NotFound />;
  }

  return (
    <div className="bg-background text-foreground">
      <InvestmentDetailHero investment={investment} />

      <div className="container px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 lg:pr-6">
            <div className="space-y-16">
              <div id="details"><NewDetails investment={investment} /></div>
              <div id="overview"><Overview investment={investment} /></div>
              <div id="premise"><Premise investment={investment} /></div>
              <div id="essentials"><Essentials investment={investment} /></div>
              <div id="docs"><Documents investment={investment} /></div>
              <div id="content"><Content investment={investment} /></div>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="sticky top-24">
              <FinancialsTable investment={investment} />
              <div className="mt-6">
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button className="w-full">Invest Now</Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    {investment.status === 'Open' ? (
                      <>
                        <AlertDialogHeader>
                          <AlertDialogTitle>Redirecting to Investment Dashboard</AlertDialogTitle>
                          <AlertDialogDescription>
                            You will be redirected to our secure investment portal at app.alta-x.com to complete your investment.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Cancel</AlertDialogCancel>
                          <AlertDialogAction onClick={() => window.open('https://app.alta-x.com', '_blank')}>
                            Continue
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </>
                    ) : (
                      <>
                        <AlertDialogHeader>
                          <AlertDialogTitle>Expression of Interest</AlertDialogTitle>
                          <AlertDialogDescription>
                            This investment is currently accepting expressions of interest. Please send us an email to proceed.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Cancel</AlertDialogCancel>
                          <AlertDialogAction onClick={() => window.location.href = 'mailto:invest@alta-x.com'}>
                            Send Email
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </>
                    )}
                  </AlertDialogContent>
                </AlertDialog>
                <p className="text-center text-xs text-muted-foreground mt-4">You will be redirected to our secure investment portal.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetail;
